import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="vibrant-footer">
      <div className="container">
        <div className="vibrant-footer-top">
          <div className="vibrant-footer-brand">
            <div className="footer-logo">
              <div className="logo-icon-sm">
                <span className="material-symbols-outlined">visibility</span>
              </div>
              <span className="logo-text">CataractLensAdvisor</span>
            </div>
          </div>
          <div className="vibrant-footer-links">
            <Link to="/legal/privacy">Privacy Policy</Link>
            <Link to="/legal/terms">Terms of Service</Link>
            <Link to="/legal/disclaimer">Medical Disclaimer</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
        <div className="vibrant-footer-bottom">
          <p>© {currentYear} CataractLensAdvisor. For educational purposes only. Always consult a medical professional.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
